import {Field} from 'formik';

import {SimpleGrid} from '@mantine/core';

import {FormikTextInput} from '@flexinet/ui-components';
import {ReportTypesDropdown} from '../../report-types/inputs/ReportTypesDropdown';
import {CurrencyDropdown} from '../inputs/CurrencyDropdown';
import {TimezoneDropdown} from '../inputs/TimezoneDropdown';
import {TimestampInput} from '../inputs/TimestampInput';
import {ReportingCategoryDropdown} from '../inputs/ReportingCategoryDropdown';


export const FormComponent = () => {

    return (
        <SimpleGrid cols={1}>

            <Field
                name='reportType'
                label='Report Type'
                description='Please select the report type'
                component={ReportTypesDropdown}
                withAsterisk
            />

            <Field
                name='currency'
                label='Currency'
                description='Select the currency for the report'
                component={CurrencyDropdown}
            />

            <Field
                name='timezone'
                label='Timezone'
                description='Select the timezone for the report'
                component={TimezoneDropdown}
            />

            <Field
                name='intervalStart'
                label='Interval Start'
                description='Start of the reporting interval'
                component={TimestampInput}
            />

            <Field
                name='intervalEnd'
                label='Interval End'
                description='End of the reporting interval'
                component={TimestampInput}
            />

            <Field
                name='reportingCategory'
                label='Reporting Category'
                description='Category of balance transactions to include'
                component={ReportingCategoryDropdown}
            />

            <Field
                name='connectedAccount'
                label='Connected Account'
                description='Connected account ID'
                component={FormikTextInput}
            />

            <Field
                name='payout'
                label='Payout'
                description='Payout ID to filter by'
                component={FormikTextInput}
            />

        </SimpleGrid>
    );
};
